module.exports = __webpack_public_path__ + "static/media/CERTIFYING.9fe65e6c.png";